import { format, isToday } from 'date-fns';

const FormattedDate = ({ date, className }) => {
  if (!date) return null;
  
  const dateObj = date.toDate ? date.toDate() : date;
  
  if (isToday(dateObj)) {
    return <span className={className}>Today</span>;
  }
  
  // Show formatted date
  return <span className={className}>{format(dateObj, 'MMM d, yyyy')}</span>;
};

export default FormattedDate;
